/**
 * Whether anybody asked for the diagnostics, and nothing else.
 *
 * This is the only part of `diag/` that is always in the bundle alongside the fault sink, so it is
 * kept to a URL read and a dynamic import. Everything the overlay needs lands in its own chunk and
 * is never fetched by a player who did not ask, which is what keeps the initial load inside the
 * budget `tools/bin/bundle-check.sh` enforces.
 *
 * It ships in production on purpose. The device this exists for is somebody's phone loading the
 * deployed build, and a development-only diagnostic would be one that can never be pointed at the
 * machine that has the fault.
 */

import { publishFaults } from '@/diag/faultSink';

const DIAG_PARAM = 'diag';

export function openDiagnosticsIfAsked(): void {
  publishFaults();
  if (new URLSearchParams(window.location.search).get(DIAG_PARAM) !== '1') return;
  void import('@/diag/diagOverlay').then(
    (module) => {
      module.openDiagOverlay();
    },
    () => undefined,
  );
}
